import gsap from 'gsap';

// Fonction pour préparer les strokes (remplace drawSVG)
const prepareStroke = (elements: Element[]) => {
    elements.forEach((el: any) => {
        if (el.getTotalLength) {
            const length = el.getTotalLength();
            el.style.strokeDasharray = length;
            el.style.strokeDashoffset = length;
        }
    });
};

export const initFlowerAnimation = () => {
    // Sélectionner les éléments
    const strokesLeftBottom = Array.from(
        document.querySelectorAll('#LeftBottomGroup_1_ path[id^=Stroke]')
    ).reverse();

    const strokesLeftTop = Array.from(
        document.querySelectorAll('#LeftTopGroup_1_ path[id^=Stroke]')
    ).reverse();

    const strokesRightBottom = Array.from(
        document.querySelectorAll('#RightBottomGroup_1_ path[id^=Stroke]')
    ).reverse();

    const strokesRightTop = Array.from(
        document.querySelectorAll('#RightTopGroup_1_ path[id^=Stroke]')
    ).reverse();

    // Groupes
    const stemGroup1 = ['#Stem2_1_', '#Stem3_1_', '#Stem4_1_', '#Stem5a_1_', '#Stem5b_1_', '#Stem6_1_', '#Stem7a_1_', '#Stem7b_1_', '#Stem7c_1_', '#Stem8_1_'];
    const stemGroup2 = ['#Stem17_1_', '#Stem18_1_', '#Stem19_1_', '#Stem20a_1_', '#Stem20b_1_', '#Stem21_1_', '#Stem22a_1_', '#Stem22b_1_', '#Stem22c_1_', '#Stem23_1_'];
    const stemGroup3 = ['#Stem10_1_', '#Stem11_1_', '#Stem12a_1_', '#Stem12b_1_'];
    const stemGroup4 = ['#Stem26_1_', '#Stem27_1_', '#Stem28a_1_', '#Stem28b_1_'];
    const stemGroup5 = ['#Stem13a_1_', '#Stem13b_1_', '#Stem13c_1_'];
    const stemGroup6 = ['#Stem29a_1_', '#Stem29b_1_', '#Stem29c_1_'];

    const leafGroup1 = ['#Leaf2_1_', '#Leaf17_1_'];
    const leafGroup2 = ['#Leaf4_1_', '#Leaf5a_1_', '#Leaf5b_1_'];
    const leafGroup3 = ['#Leaf19_1_', '#Leaf20a_1_', '#Leaf20b_1_'];
    const leafGroup4 = ['#Leaf11_1_', '#Leaf12a_1_', '#Leaf12b_1_'];
    const leafGroup5 = ['#Leaf27_1_', '#Leaf28a_1_', '#Leaf28b_1_'];
    const leafGroup6 = ['#Leaf13a_1_', '#Leaf13b_1_', '#Leaf13c_1_'];
    const leafGroup7 = ['#Leaf29a_1_', '#Leaf29b_1_', '#Leaf29c_1_'];

    const budGroup1 = ['#Bud3_1_', '#Bud6_1_'];
    const budGroup2 = ['#Bud18_1_', '#Bud21_1_'];
    const budGroup3 = ['#Bud7a_1_', '#Bud7b_1_', '#Bud7c_1_', '#Bud8_1_'];
    const budGroup4 = ['#Bud22a_1_', '#Bud22b_1_', '#Bud22c_1_', '#Bud23_1_'];
    const budGroup5 = ['#Bud10_1_', '#Bud26_1_'];

    const dots = '#Dots_1_';

    // Préparer tous les strokes
    const allStems = [
        ...stemGroup1, ...stemGroup2, ...stemGroup3,
        ...stemGroup4, ...stemGroup5, ...stemGroup6,
        '#Stem16_1_', '#Stem1_1_', '#Stem9_1_', '#Stem25_1_'
    ];

    allStems.forEach(stem => {
        const el = document.querySelector(stem);
        if (el) prepareStroke([el]);
    });

    prepareStroke(strokesLeftBottom);
    prepareStroke(strokesRightBottom);
    prepareStroke(strokesLeftTop);
    prepareStroke(strokesRightTop);

    // Timeline
    const tl = gsap.timeline()
        .set('#Footer_group_1_', { autoAlpha: 1 })

        // Stems principaux - POSITION CORRECTE: après 'start'
        .fromTo(
            ['#Stem16_1_', '#Stem1_1_'],
            { strokeDashoffset: (i, el: any) => el.getTotalLength() },
            { strokeDashoffset: 0, duration: 1.5 },
            'start'
        )

        // BaseGroup16 - POSITION: 1.2 secondes APRÈS 'flower1'
        .fromTo(
            '#BaseGroup16_1_ path',
            { autoAlpha: 1, scale: 0, transformOrigin: '-10% 130%' },
            { duration: 1, scale: 1 },
            'flower1+=1.2' // ← CORRECTION: += au lieu de deuxième paramètre
        )
        .fromTo(
            '#PinkFlowerGroup16_1_',
            { autoAlpha: 1, scale: 0, transformOrigin: '35% 110%' },
            { duration: 2, scale: 1 },
            'flower1-=0.55'
        )

        // BaseGroup1 - POSITION: 1.2 secondes APRÈS 'flower1'
        .fromTo(
            '#BaseGroup1_1_ path',
            { autoAlpha: 1, scale: 0, transformOrigin: '90% 130%' },
            { duration: 1, scale: 1 },
            'flower1+=1.2' // ← CORRECTION
        )
        .fromTo(
            '#PinkFlowerGroup1_1_',
            { autoAlpha: 1, scale: 0, transformOrigin: '65% 110%' },
            { duration: 2, scale: 1 },
            'flower1-=0.55'
        )

        // Stems 9 et 25
        .fromTo(
            ['#Stem9_1_', '#Stem25_1_'],
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2 },
            'flower1+=0.5'
        )

        // Flowers 9 et 25
        .fromTo(
            '#BaseGroup9_1_ path',
            { autoAlpha: 1, scale: 0, transformOrigin: '-10% 130%' },
            { duration: 1, scale: 1 },
            'flower2-=0.5'
        )
        .fromTo(
            '#PinkFlowerGroup9_1_',
            { autoAlpha: 1, scale: 0, transformOrigin: '5% 110%' },
            { duration: 2, scale: 1 },
            'flower2'
        )
        .fromTo(
            '#BaseGroup25_1_ path',
            { autoAlpha: 1, scale: 0, transformOrigin: '105% 130%' },
            { duration: 1, scale: 1 },
            'flower2-=0.5'
        )
        .fromTo(
            '#PinkFlowerGroup25_1_',
            { autoAlpha: 1, scale: 0, transformOrigin: '95% 110%' },
            { duration: 2, scale: 1 },
            'flower2'
        )

        // Stems groups - autoAlpha déjà dans le set initial
        .fromTo(
            stemGroup1,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 0.5 },
            'start+=0.1'
        )
        .fromTo(
            stemGroup2,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 0.5 },
            'start+=0.1'
        )
        .fromTo(
            stemGroup3,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 0.5 },
            'flower2-=1.5'
        )
        .fromTo(
            stemGroup4,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 0.5 },
            'flower2-=1.5'
        )
        .fromTo(
            stemGroup5,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 0.5 },
            'flower3-=1'
        )
        .fromTo(
            stemGroup6,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 0.5 },
            'flower3-=1'
        )

        // Leaves - transformOrigin dans FROM !!
        .fromTo(
            leafGroup1,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["80% 45%", "20% 45%"][i] // ← Dans FROM
            },
            { duration: 2, scale: 1 },
            'flower1-=1'
        )
        .fromTo(
            leafGroup2,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["80% 25%", "60% 35%", "70% 75%"][i] // ← Dans FROM
            },
            { duration: 2, stagger: 0.5, scale: 1 },
            'flower1'
        )
        .fromTo(
            leafGroup3,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["20% 25%", "40% 35%", "30% 75%"][i]
            },
            { duration: 2, stagger: 0.5, scale: 1 },
            'flower1'
        )
        .fromTo(
            leafGroup4,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["90% 70%", "100% 100%", "0% 90%"][i]
            },
            { duration: 2, stagger: 0.5, scale: 1 },
            'flower2'
        )
        .fromTo(
            leafGroup5,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["10% 70%", "0% 100%", "100% 90%"][i]
            },
            { duration: 2, stagger: 0.5, scale: 1 },
            'flower2'
        )
        .fromTo(
            leafGroup6,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["0% 90%", "10% 50%", "70% 60%"][i]
            },
            { duration: 2, stagger: 0.5, scale: 1 },
            'flower3'
        )
        .fromTo(
            leafGroup7,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ["100% 90%", "90% 50%", "30% 60%"][i]
            },
            { duration: 2, stagger: 0.5, scale: 1 },
            'flower3'
        )

        // Buds - transformOrigin dans FROM
        .fromTo(
            budGroup1,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ['220% -10%', '55% 100%'][i]
            },
            { duration: 2, scale: 1, stagger: 2.75 },
            'flower1-=0.75'
        )
        .fromTo(
            budGroup2,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ['-120% -10%', '45% 100%'][i]
            },
            { duration: 2, scale: 1, stagger: 2.75 },
            'flower1-=0.75'
        )
        .fromTo(
            budGroup3,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ['10% 110%', '0% 100%', '0% 100%', '80% 100%'][i]
            },
            { duration: 2, scale: 1, stagger: 0.5 },
            'flower2'
        )
        .fromTo(
            budGroup4,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ['90% 110%', '100% 100%', '100% 100%', '20% 100%'][i]
            },
            { duration: 2, scale: 1, stagger: 0.5 },
            'flower2'
        )
        .fromTo(
            budGroup5,
            {
                autoAlpha: 1,
                scale: 0,
                transformOrigin: (i) => ['-50% 120%', '150% 120%'][i]
            },
            { duration: 2, scale: 1 },
            'flower2-=0.5'
        )

        // Strokes
        .fromTo(
            strokesLeftBottom,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 1 },
            1
        )
        .fromTo(
            strokesRightBottom,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 1 },
            1
        )
        .fromTo(
            strokesLeftTop,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 1 },
            'flower1+=0.5'
        )
        .fromTo(
            strokesRightTop,
            { strokeDashoffset: (i, el: any) => el.getTotalLength(), autoAlpha: 1 },
            { strokeDashoffset: 0, duration: 2, stagger: 1 },
            'flower1+=0.5'
        )

        // Dots
        .fromTo(
            dots,
            { autoAlpha: 0 },
            { autoAlpha: 1, duration: 6, ease: "expo.out" },
            'flower3+=1'
        )
        .fromTo(
            dots,
            { scale: 0, transformOrigin: '50% 50%' },
            { scale: 1, duration: 5, ease: "expo.out" },
            'flower3'
        );

    return () => {
        tl.kill();
    };
};